export default {
  common: {
    orderNo: 'Order number',
    customerName: 'Customer name',
    productName: 'Product name',
    packageType: 'Package type',
    lotNo: 'Lot number',
    orderDate: 'Order date',
    reset: 'Reset',
    query: 'Query',
    import: 'Import',
    export: 'Export',
    chipName: 'Chip name',
    processType: 'Process type',
    expressageNo: 'Expressage number',
    expressageType: 'Expressage type',
    expressage: 'expressage',
    boxNo: 'Box number',
    storePosition: 'Store position',
    count: 'Count',
    operate: 'Operate',
    detail: 'Detail',
    status: 'Status',
    new: 'New',
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    importDate: 'Import Date',
    caseNo: 'Case Number',
    contact: 'contact',
    contactPhone: 'Contact Phone',
    address: 'Address',
    sure: 'Sure',
    comment: 'Comment',
    back: 'Back',
    delete: 'Delete',
    add: 'Add',
    prevStep: 'Prev Step',
    nextStep: 'Next Step',
    submit: 'Submit',
    productOrderNo: 'Product order number',
    productOrder: 'Product order',
    passCount: 'Pass count',
    failCount: 'Fail count',
    expectedDeliveryNumber: 'Expect Delivery Number',
    deliveryNumber: 'Delivery number',
    deliveredNumber: 'Delivered Number',
    newlyAdded: 'Add',
    edit: 'Edit',
    finish: 'Finish',
    complete: 'Finish',
    cancelFinish: 'CancelFinish',
    success: 'Success',
    operateTime: 'Operate Time',
    deleteSuccess: 'Delete Success',
    updateSuccess: 'Update Success',
    addSuccess: 'Add Success',
    saveSuccess: 'Save Success',
    submitSuccess: 'Submit Success',
    uploadSuccess: 'Upload success',
    uploadFailure: 'Upload failure',
    associateSuccess: 'Associate Success',
    scanSuccess: 'Scan Success',
    disassociateSuccess: 'Disassociate Success',
    sizeNotExceed2M: 'File size should not exceed 2M',
    empty: 'Empty',
    priorityLevel: 'Priority Level',
    isMixed: 'isMixed',
    startDevicen: 'Start DeviceNO',
    endDevicen: 'End DeviceNO',
    partNo: 'PARTNO printed on label',
    yes: 'Yes',
    no: 'No',
    cancelEntrySuccess: 'Cancel Entry Success',
    deliverySuccess: 'Delivery Success',
    cancelDeliverySuccess: 'Cancel Delivery Success',
    expectCount: 'Expect Count',
    subNo: 'sub-number',
    entryTime: 'entry time',
    storePassCount: 'Store Pass Count',
    storeFailCount: 'Store Fail Count',
    associate: 'Associate',
    number: 'Number',
    orderTime: 'Order Time',
    binLevel: 'binLevel',
    returnTicket: 'return Ticket',
    print: 'Print',
    weight: 'Weight',
    stylePreview: 'Style Preview',
    contractNo: 'Contract Number',
    grossWeight: 'Gross Weight',
    netWeight: 'Net Weight',
    labelType: 'Label Type',
    reprint: 'Reprint',
    supplierCode: 'Supplier Code',
    keyword: 'Keyword',
    labelName: 'Label Name',
    productName2: 'Product Name',
    deviceCategory: 'Device Category',
    deviceAbbreviation: 'Device Abbreviation',
    deviceModel: 'Device Model',
    deviceNumber: 'Device Number',
    productionDate: 'Production Date',
    installDate: 'Install Date',
    supportProducts: 'Support Products',
    dailyEnergy: 'Daily Energy',
    softwareVersion: 'Software Version',
    other: 'other',
    rowTestDevice: 'Row Test Device',
    columnTestDevice: 'Column Test Device',
    normal: 'Normal',
    closedBeta: 'Closed Beta',
    forSale: 'For Sale',
    scrapped: 'Scrapped',
    component: 'Sub-device',
    testReport: 'Test Report',
    deliveryReport: 'Delivery Report',
    deliveryCheckReport: 'Delivery Check Report',
    componentName: 'Sub Device Name',
    componentModel: 'Sub Device Model',
    componentNumber: 'Sub Device Number',
    dailyProductionCapacity: 'Daily Production Capacity',
    label: 'label',
    printLabel: 'Print Label',
    history: 'History',
    deviceHistory: 'Device History',
    componentHistory: 'Sub Device History',
    updateTime: 'Update Time',
    shipmentNumber: 'Shipment Number',
    upload: 'Upload',
    device: 'Device',
    selectDevice: 'Select device',
    selectComponent: 'Select component',
    deliveryDevice: 'Delivery device',
    exportDevice: 'Export device list',
    exportComponentList: 'Export component list',
    revise: 'Revise',
    associatedDevice: 'Associated Device',
    selected: 'selected',
    under: 'under',
    aTotalOf: 'A total of',
    unit: 'unit',
    deliveryList: 'Delivery list',
    componentSerialNo: 'Component Serial Number',
    waferNo: 'Wafer Number',
    waferCount: 'Wafer Count',
    moduleNo: 'Module No.',
    moduleNoQrCode: 'Module No. QR Code',
    category: 'Category',
    identification: 'Identification',
  },
  login: {
    title: 'ERP System',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    pleaseEnterCorrectName: 'Please enter the correct user name',
    pleaseEnterCorrectPwd: 'The password can not be empty',
    loginSuccess: 'Login success',
    exitTheAccountAndLoggedIn: 'Do you exit the account and logged in?',
    theCurrentUserLogsInElsewhere: 'The current user logs in elsewhere',
  },
  remindInfo: {
    warning: 'Warning',
    confirm: 'OK',
    cancel: 'Cancel',
  },
  header: {
    title: 'Management System',
    username: 'Hello!',
    logOut: 'Log out',
  },
  incomingOrder: {
    incoCount: 'Incoming count',
    outputCount: 'Output count',
    finishCount: 'Finish count',
    sendCount: 'Send Count',
    expectOverTime: 'Expect over date',
    newOrders: 'New Orders',
    essentialInformation: 'Essential Information',
    orderDetails: 'Order Details',
    incomingOrderNo: 'Incoming orderNo',
    priorityLevel: 'Priority level',
    expectIncomingDate: 'Expect incoming date',
    contact: 'Contact',
    contactPhone: 'Contact Phone',
    expectFinishDate: 'Expect finish date',
    expectOverDate: 'Expect over date',
    startDevicen: 'Start DeviceNO',
    endDevicen: 'End DeviceNO',
    binLevel: 'Bin level',
    isMixed: 'Mixed',
    attachment: 'attachment',
    upload: 'Upload',
    comment: 'Comment',
    customerNameCanNotBeEmpty: 'Customer name can\'t be empty',
    productNameCanNotBeEmpty: 'Product name can\'t be empty',
    factoryCanNotBeEmpty: 'Factory can\'t be empty',
    processTypeCanNotBeEmpty: 'Process type can\'t be empty',
    incomingOrderNoCanNotBeEmpty: 'Incoming orderNo can\'t be empty',
    priorityLevelCanNotBeEmpty: 'Priority level can\'t be empty',
    orderDateCanNotBeEmpty: 'Order date can\'t be empty',
    expectIncomingDateCanNotBeEmpty: 'Expect incoming date can\'t be empty',
    contactCanNotBeEmpty: 'Contact can\'t  Be Empty',
    expectFinishDateCanNotBeEmpty: 'Expect finish date can\'t be empty',
    expectOverDateCanNotBeEmpty: 'Expect over date can\'t be empty',
    startDevicenCanNotBeEmpty: 'Start DeviceNO can\'t be empty',
    endDevicenCanNotBeEmpty: 'End DeviceNO can\'t be empty',
    binLevelCanNotBeEmpty: 'Bin level can\'t be empty',
    isMixedCanNotBeEmpty: 'Mixed can\'t be empty',
    createSuccess: 'Create success',
    updateSuccess: 'Update success',
    thisActionWillDeleteTheProductsInThisOrder: 'This action will delete the products in this order, Whether to continue?',
    thisActionWillDeleteThisOrder: 'This action will delete this order, Whether to continue?',
    manyTypesOfOutsourcedOrderNumberInImportedData: 'There are many types of Outsourced order number in imported data',
    anOrderCanOnlyHaveAtMostOneAttachment: 'An order can have at most one attachment',
    orderDateCanNotBeLaterThanExpectedArrivalDate: 'Order date cannot be later than expected arrival date',
    expectedArrivalDateCanNotBeEarlierThanOrderDate: 'Expected arrival date cannot be earlier than order date',
    expectedCompletionDateCanNotBeEarlierThanOrderDate: 'Expected completion date cannot be earlier than order date',
  },
  incomeStorage: {
    operaterName: 'Operater name',
    operaterTime: 'Operater time',
    manyTypesOfProductNamesInImportedData: 'There are many types of product names in imported data',
    manyTypesOfChipNamesInImportedData: 'There are many types of chip names in imported data',
    manyTypesOfPackageTypesInImportedData: 'There are many types of package types in imported data',
    thereCanOnlyBeOneLotNoInABox: 'There can only be one lot number in a box',
    importedFileFormatIncorrect: 'Incorrect format of imported file',
    importedDataFormatIncorrect: 'Incorrect format of imported data',
    importedDataIsEmpty: 'Import data is empty',
    importSuccess: 'Import success',
    incomingImport: 'Incoming Import',
    explain: 'Explain',
    importInfo: '',
    import: 'Import',
    example: 'Example',
    selectFile: 'Select File',
    updateAt: 'update time',
    editBox: 'Edit Box',
    boxInfo: 'Box Info',
    caseInfo: 'Case Info',
    thisActionWillDeleteTheCase: 'This action will delete the case, Whether to continue?',
    thisActionWillCancelEntryTheBox: 'This action will cancel entry the box, Whether to continue?',
    thisActionWillDeliveryTheBox: 'This action will delivery the box, Whether to continue?',
    thisActionWillCancelDeliveryTheBox: 'This action will cancel delivery the box, Whether to continue?',
    deleteSuccess: 'Delete Success',
    updateSuccess: 'Update Success',
    addSuccess: 'Add Success',
    addCase: '添加盒子',
    editCase: '编辑盒子',
  },
  deliveryGoods: {
    newOrder: 'New Order',
    sureBuild: 'Sure Build',
    selected: 'Selected',
    orders: 'orders',
    completeOrder: 'Complete Order!',
    expressageTypeCanNotBeEmpty: 'Expressage Type can\'t be empty',
    expressageCanNotBeEmpty: 'Expressage can\'t be empty',
    expressageNoCanNotBeEmpty: 'Expressage number can\'t be empty',
    selectCustomerInformation: 'Select customer Information',
    chooseExpressDelivery: 'Choose express delivery',
    chooseBinLevel: 'choose binLevel',
    confirmedQuantity: 'Confirmed quantity',
    expressReturnTicket: 'Express return ticket',
    saveXLSX: 'save XLSX',
    saveAndPrint: 'Save and Print',
    requestExpress: 'express',
    selectTheOrderFirst: 'Please select the order first',
    deliveryNumberCanNotBeEmpty: 'Delivery number can\'t be empty',
    deliveryNumberMustMoreThan0: 'Delivery number must more than 0',
    expectedDeliveryNumberCanNotBeEmpty: 'expected delivery number can\'t be empty',
    expectedDeliveryNumberMustMoreThan0: 'expected delivery number must more than 0',
    theProductTypeOfTheSelectedOrderMustBeTheSame: 'The product type of the selected order must be the same',
    buildSuccess: 'Build success',
    thisActionWillDeleteTheDeliveryOrder: 'This action will delete the delivery order, Whether to continue?',
    deliveryConfirmation: 'Confirmation',
    scanReturnTicket: 'Scan',
    returnTicketCanNotBeEmpty: 'return ticket can\'t be empty',
    orderInfo: 'Order Info',
    uploadReturnTicket: 'Upload Return Ticket',
    deliveryInformation: 'Delivery Information',
    customerInformation: 'Customer Information',
    expressInformation: 'Express Information',
    productOrderNoCanNotBeEmpty: 'Product Order Number can\'t be empty',
    orderDateCanNotBeEmpty: 'Order Date can\'t be empty',
    orderTimeCanNotBeEmpty: 'Order Time can\'t be empty',
    associatedBoxes: 'Associated Boxes',
    statusCanNotBeEmpty: 'status Date can\'t be empty',
    chipCountLessThanExpectCount: 'The total number of associated box chips is less than the expected number of shipments. Continue to print the shipment order?',
    binLevelArrCanNotBeEmpty: 'binLevel can\'t be empty',
  },
  incomeApp: {
    associatedBox: 'Associated Box',
    scanningExpress: 'Scanning Express',
    associatedBoxes: 'Associated Box',
    disassociatedBox: 'Disassociated Box',
    thisActionWillDisassociatedBox: 'This action will disassociated the box, Whether to continue?',
    spread: 'spread',
    retract: 'retract',
  },
  factoryLabelPrint: {
    templateContentEditing: 'Template Content Editing',
    processingOrderNo: 'Processing Order Number',
    purchaseOrderNo: 'Purchase Order Number',
    materialNo: 'Material Number',
    specificationNo: 'Specification Number',
    deliveryDate: 'Delivery Date',
    storageDate: 'Storage Date',
    processingOrderNoCanNotBeEmpty: 'Processing order number can\'t be empty',
    purchaseOrderNoCanNotBeEmpty: 'Purchase order number can\'t be empty',
    materialNoCanNotBeEmpty: 'Material Number can\'t be empty',
    specificationNoCanNotBeEmpty: 'Specification number can\'t be empty',
    deliveryDateCanNotBeEmpty: 'Delivery date can\'t be empty',
    storageTimeCanNotBeEmpty: 'Storage date date can\'t be empty',
    productNameOrSpecification: 'ProductName/Specification',
    qiangLiBatchNo: 'QiangLi Batch Number',
    productNameOrSpecificationCanNotBeEmpty: 'ProductName/Specification can\'t be empty',
    orderNoCanNotBeEmpty: 'Order Number can\'t be empty',
    qiangLiBatchNoCanNotBeEmpty: 'QiangLi Batch Number can\'t be empty',
    orderNumber: 'Order Number',
    materialDescription: 'Material Description',
    productionBatch: 'Production Batch',
    orderNumberCanNotBeEmpty: 'Order Number can\'t be empty',
    materialDescriptionCanNotBeEmpty: 'Material Description can\'t be empty',
    productionBatchCanNotBeEmpty: 'Production can\'t be empty',
    customerMaterialNo: 'Customer Material Number',
    customerMaterialNoCanNotBeEmpty: 'Customer Material Number can\'t be empty',
    materialName: 'Material Name',
    materialNameCanNotBeEmpty: 'Material Name can\'t be empty',
    partNoCanNotBeEmpty: 'P/N can\'t be empty',
    trackingNoCanNotBeEmpty: 'Tracking No can\'t be empty',
    packageTypeCanNotBeEmpty: 'Package Type can\'t be empty',
    resultCanNotBeEmpty: 'Result can\'t be empty',
    markingCanNotBeEmpty: 'Marking can\'t be empty',
    binLevelCanNotBeEmpty: 'Bin Level can\'t be empty',
    materialNo2: 'Material Number',
    materialNo2CanNotBeEmpty: 'Material Number can\'t be empty',
    customerModel: 'Customer Model',
    customerModelCanNotBeEmpty: 'Customer Model can\'t be empty',
    productionDate: 'Production Date',
    productionDateCanNotBeEmpty: 'Production Date can\'t be empty',
    qiangLiBatchNoFormatIncorrect: 'QiangLi Batch Number Format Incorrect',
    lotNoOfOutBox: 'lot Number Of out box',
    lotNoOfOutBoxCanNotBeEmpty: 'lot Number Of out box can\'t be empty',
    moduleNoCanNotBeEmpty: 'Module No. can\'t be empty',
    moduleNoQrCodeCanNotBeEmpty: 'QR code can\'t be empty',
  },
  factoryLabelHistory: {
    labelEdit: 'Label Edit',
    thisActionWillDeleteThisLabel: 'This action will delete this label, Whether to continue?',
  },
  errorPage404: {
    errorInfo: 'Please check that the URL you entered is correct, or click the button below to return to the homepage.',
    returnHome: 'Back to home',
  },
  validate: {
    boxNoCanNotBeEmpty: 'Box number can\'t be empty',
    boxNoCanNotBePureNumbers: 'Box number can\'t be pure numbers',
    boxNoFormatIncorrect: 'Box number Format incorrect',
    caseNoCanNotBeEmpty: 'Case number can\'t be empty',
    caseNoCanNotBePureNumbers: 'Case number can\'t be pure numbers',
    caseNoFormatIncorrect: 'Case number Format incorrect',
    lotNoCanNotBeEmpty: 'Lot number can\'t be empty',
    lotNoCanNotBePureNumbers: 'Lot number can\'t be pure numbers',
    lotNoFormatIncorrect: 'Lot number Format incorrect',
    waferCountCanNotBeEmpty: 'Wafer count can\'t be empty',
    waferCountMustBeAPositiveInteger: 'Wafer count must be a positive integer',
    countCanNotBeEmpty: 'Count can\'t be empty',
    countMustBeAPositiveInteger: 'Count must be a positive integer',
    priceCanNotBeEmpty: 'price can\'t be empty',
    priceMustBeANumberInteger: 'price must be a number integer',
    priceHasAtMostTwoDecimalPlaces: 'price has at most two decimal places',
    priceMustBeGreaterThan0: 'price must be greater than 0',
    contactPhoneCanNotBeEmpty: 'contact phone can\'t be empty',
    contactPhoneFormatIncorrect: 'contact phone format incorrect',
    productOrderNoCanNotBeEmpty: 'product orderNo can\'t be empty',
    expressageNoCanNotBeEmpty: 'Expressage number  can\'t be empty',
    customerNameCanNotBeEmpty: 'Customer name can\'t be empty',
    productNameCanNotBeEmpty: 'Product name can\'t be empty',
    factoryCanNotBeEmpty: 'Factory can\'t be empty',
    processTypeCanNotBeEmpty: 'Process type can\'t be empty',
    incomingOrderNoCanNotBeEmpty: 'Incoming orderNo can\'t be empty',
    incomingOrderNoFormatError: 'Incoming orderNo format error',
    priorityLevelCanNotBeEmpty: 'Priority level can\'t be empty',
    orderDateCanNotBeEmpty: 'Order date can\'t be empty',
    expectIncomingDateCanNotBeEmpty: 'Expect incoming date can\'t be empty',
    contactCanNotBeEmpty: 'Contact can\'t  Be Empty',
    expectFinishDateCanNotBeEmpty: 'Expect finish date can\'t be empty',
    expectOverDateCanNotBeEmpty: 'Expect over date can\'t be empty',
    startDevicenCanNotBeEmpty: 'Start DeviceNO can\'t be empty',
    endDevicenCanNotBeEmpty: 'End DeviceNO can\'t be empty',
    partNoCanNotBeEmpty: 'PARTNO can\'t be empty',
    waferNoCanNotBeEmpty: 'WaferNo can\'t be empty',
    propCanNotBeEmpty: 'Prop can\'t be empty',
    binLevelCanNotBeEmpty: 'Bin level can\'t be empty',
    isMixedCanNotBeEmpty: 'Mixed can\'t be empty',
    productDetailsCanNotBeEmpty: 'Product details can\'t be empty',
    weightCanNotBeEmpty: 'weight can\'t be empty',
    weightMustBeANumber: 'weight must be a number',
    weightMustBeAPositiveNumber: 'weight must be a positive number',
    contractNoCanNotBeEmpty: 'Contract Number can\'t be empty',
    grossWeightCanNotBeEmpty: 'Gross Weight can\'t be empty',
    grossWeightMustBeANumber: 'Gross Weight must be a number',
    grossWeightMustBeAPositiveNumber: 'Gross Weight must be a positive number',
    netWeightCanNotBeEmpty: 'Net Weight can\'t be empty',
    netWeightMustBeANumber: 'Net Weight must be a number',
    netWeightMustBeAPositiveNumber: 'Net Weight must be a positive number',
    trackingNoCanNotBeEmpty: 'Tracking No can\'t be empty',
    trackingNoCanNotBePureNumbers: 'Tracking No can\'t be pure numbers',
    trackingNoFormatIncorrect: 'Tracking No Format incorrect',
    deviceCategoryCanNotBeEmpty: 'Device Category can\'t be empty',
    addressCanNotBeEmpty: 'address can\'t be empty',
    deviceNameCanNotBeEmpty: 'Device Name can\'t be empty',
    deviceModelCanNotBeEmpty: 'Device Model can\'t be empty',
    deviceNumberCanNotBeEmpty: 'Device Number can\'t be empty',
    productionDateCanNotBeEmpty: 'Production Date can\'t be empty',
    statusCanNotBeEmpty: 'Status can\'t be empty',
    componentNameCanNotBeEmpty: 'Sub device name can\'t be empty',
    componentModelCanNotBeEmpty: 'Sub device model can\'t be empty',
    componentNumberCanNotBeEmpty: 'Sub device number can\'t be empty',
  },
  priorityLevel: {
    urgent: 'urgent',
    important: 'important',
    commonly: 'commonly',
  },
  device: {
    addNewDevice: 'Add New Device',
    addNewComponent: 'Add New Sub Device',
    componentManagement: 'Sub Device Management',
    deviceDetail: 'Device Detail',
    componentDetail: 'Sub Device Detail',
    aDeviceCanOnlyHaveAtMostOneTestReport: 'A device can only have at most one test report',
    aDeviceDeliveryCanOnlyHaveAtMostOneDeliveryReport: 'A device delivery can only have at most one delivery report',
    aDeviceDeliveryCanOnlyHaveAtMostOneDeliveryCheckReport: 'A device delivery can only have at most one delivery check report',
    thisActionWillDeleteThisDevice: 'This action will delete this device, Whether to continue?',
    thisActionWillDeleteThisComponent: 'This action will delete this component, Whether to continue?',
    componentInfoMissing: 'Sub device info missing',
    dailyProductionCapacityCanNotBeEmpty: 'Daily Production Capacity can\'t be empty',
    dailyProductionCapacityMustBeAPositiveInteger: 'Daily Production Capacity must be a positive integer',
    deviceInfoMissing: 'Device info missing',
    addNewDeviceDelivery: 'Add new device delivery',
    shipmentNumberCanNotBeEmpty: 'Shipment Number can\'t be Empty',
    deviceCanNotBeEmpty: 'Device can\'t be Empty',
    thisActionWillDeleteThisDeviceDelivery: 'This action will delete this device delivery, Whether to continue?',
    deviceDeliveryDetail: 'Device delivery detail',
    deviceDeliveryInfoMissing: 'Device delivery info missing',
    selectTheDeviceOrComponentFirst: 'Please select the device or component first',
    confirmInfo: 'Confirm Info',
    numberIsEmpty: 'Number is empty',
    numberIsNotPositiveInteger: 'Number is not positive integer',
    numberCanNotBeEmpty: 'number can\'t be empty',
    numberMustMoreThan0: 'number must more than 0',
    editDevice: 'Edit Device',
    editComponent: 'Edit Component',
    deviceInfo: 'Device Info',
  },
};
